// @ts-nocheck
import { getApiCall, postApiCall } from "../service/httpCall";
import { API_USER_PANEL_CUSTOMIZATION_ME } from "../service/url";
import { getUserAccessToken } from "./setting";

export const PANEL_DEFAULTS = {
  theme: "light",
  display_scale: 75,
  sidebar_position: "left",
};

function isLoggedIn() {
  try {
    return Boolean(getUserAccessToken());
  } catch (e) {
    return false;
  }
}

export async function fetchPanelCustomization() {
  if (!isLoggedIn()) return null;
  return getApiCall(API_USER_PANEL_CUSTOMIZATION_ME, {});
}

let saveTimer = null;
let pending = {};

export function savePanelCustomization(partial) {
  if (!partial || typeof partial !== "object") return;
  if (!isLoggedIn()) return;

  pending = { ...pending, ...partial };

  if (saveTimer) clearTimeout(saveTimer);
  saveTimer = setTimeout(() => {
    const body = pending;
    pending = {};
    saveTimer = null;
    postApiCall(API_USER_PANEL_CUSTOMIZATION_ME, body).catch((err) => {
      console.warn("panel customization save failed:", err);
    });
  }, 400);
}
